<template>
    <div class="center w-full pl-0 pr-0 xl:pl-4 xl:pr-4 lg:pl-3 lg:pr-3">
		<div class="flex w-full justify-content-center align-items-center pt-0 pb-0 xl:pt-4 xl:pb-8 lg:pt-3 lg:pb-5">
			<div class="flex flex-column w-full surface-0 pt-4 pl-3 pr-3 pb-4 xl:p-6 lg:p-5 md:p-4 xl:border-round-xl lg:border-round-xl">
                <span class="flex text-900 font-medium mb-4 xl:mb-6 text-3xl xl:text-6xl lg:text-5xl md:text-4xl">
                    {{header[lang].name}} мерчанта
                </span>
                <div class="w-full flex flex-column">            

                    <div class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row mb-3">
                        <div class="w-full flex flex-row surface-50 gap-3
                            p-3 xl:p-4 lg:p-4 md:p-4
                            border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                            text-left">
                            <div class="flex flex-column flex-1 mb-3">
                                <span class="flex text-600 mb-2 text-sm">
                                    Мерчант:
                                </span>
                                <span v-if="merchant && merchant.name" class="flex text-700 text-2xl font-medium white-space-nowrap">
                                    {{ merchant.name }}
                                </span>
                                <Skeleton v-else height="2rem" class="border-round-md"/>
                            </div>
                            <div class="flex flex-column align-items-end">
                                <span class="flex text-600 mb-2 text-sm">
                                    Выберите период:
                                </span>
                                <Dropdown id='date' v-model="date" :options="date_list" :loading="loading" option-label="name" class='w-full border-round-lg' placeholder="Выберите дату" />
                                <div class="flex mt-3">
                                    <Button label="Обновить" @click='refresh()' :loading="loading" class="flex surface-400 border-400 text-900 border-round-lg" :disabled="!merchant" icon="pi pi-refresh" iconPos="right" size="small"/>
                                </div> 
                            </div>
                        </div>
                    </div>

                    <div class="w-full flex flex-column mb-4">
                        <Balance :data="merchant" :merchant_id="merchant_id" :is_admin="true" :loading="loading" />
                    </div>

                    <div class="w-full flex flex-column mb-4">
                        <span class="flex text-900 font-medium mb-2 text-xl xl:text-4xl lg:text-3xl md:text-2xl">
                            Статистика
                        </span>
                        <Statistics :data="merchant" :loading="loading" />    
                    </div>

                    <div class="w-full flex flex-column mb-4">
                        <span class="flex text-900 font-medium mb-2 text-xl xl:text-4xl lg:text-3xl md:text-2xl">
                            Ликвидность
                        </span>
                        <Liquidity :data="merchant" :merchant_id="merchant_id" :is_admin="true" />
                    </div>

                    <div class="w-full flex flex-column mb-4">
                        <span class="flex text-900 font-medium mb-2 text-xl xl:text-4xl lg:text-3xl md:text-2xl">
                            Карты
                        </span>
                        <div class="w-full flex flex-column">
                            <CardAdd :merchant_id="merchant_id" v-if="merchant && (isUserInGroup('admin') || isUserInGroup('manager'))" /> 
                            <CardList :cards="cards" :editing="true"/>
                        </div>
                    </div>
                </div>
			</div>
		</div>
	</div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { useRoute } from 'vue-router'
import CardList from '@/components/merchant/CardList.vue'
import CardAdd from '@/components/admin/CardAdd.vue'
import Balance from '@/components/merchant/Balance.vue'
import Statistics from '@/components/merchant/Statistics.vue'
import Liquidity from '@/components/merchant/Liquidity.vue' 

export default {
    data() {
        return {
            header: {
                en: {name: "Statistics"} ,
                ru: {name: "Cтатистика"} ,
            }, 
            merchant: null,
            merchant_id: null,
            cards: [],
            date: {
                name: 'месяц',
                val: 30
            },
            date_list: [
                {
                    name: 'сегодня',
                    val: 1
                },
                {
                    name: 'неделя',
                    val: 7
                },
                {
                    name: 'месяц',
                    val: 30
                },
                {
                    name: 'год',
                    val: 365
                },
            ],
            loading: false,
        }
    },
    components: {
        Balance,
        Statistics,
        Liquidity,
        CardList,
        CardAdd,
    },
    methods: {
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        async loadMerchant(){
            this.loading = true
            const date = (this.date && this.date.val) ? this.date.val : 30
            const merchat_data = await this.connect.get_merchant_by_id(this.merchant_id, date).then(res=>res)
            if(merchat_data.result && merchat_data.data) {
                this.merchant = merchat_data.data
                this.cards = (merchat_data.data.cards) ? merchat_data.data.cards : []
            }
            this.loading = false
            console.log(this.merchant)
        },
        async refresh(){
            this.merchant = null
            this.cards = []
            this.loadMerchant()
        },
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    watch: {
        async date() {
            this.merchant = null
            this.cards = []
            if(this.merchant_id) this.loadMerchant()
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted(){
        const route = useRoute()
        if(route.params.id!='' && this.helper.is_id(route.params.id)){
            this.merchant_id = route.params.id
            if(this.merchant_id) this.loadMerchant()
        }
    },
}
</script>